module.exports = __webpack_public_path__ + "static/landing-fd9442c4af961fea060827831cbe09fc.mp4";